const api = 'https://daospace-api.starcoin.org/main/v1';

// test api
// const api =
//   'http://k8s-default-daoapiin-a10a2591c6-298563096.ap-northeast-1.elb.amazonaws.com/dev/v1';

export default {
  api,
};
